import { render, staticRenderFns } from "./ModalConcepts.vue?vue&type=template&id=1a53b262&lang=pug&"
import script from "./ModalConcepts.vue?vue&type=script&lang=js&"
export * from "./ModalConcepts.vue?vue&type=script&lang=js&"
import style0 from "./ModalConcepts.vue?vue&type=style&index=0&id=1a53b262&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports